/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionAddRequest
 */
export interface PermissionAddRequest {
    /**
     * The ID of the workspace member to grant permission to
     * @type {string}
     * @memberof PermissionAddRequest
     */
    memberId: string;
    /**
     * The permission type to grant
     * @type {string}
     * @memberof PermissionAddRequest
     */
    permission: PermissionAddRequestPermissionEnum;
}


/**
 * @export
 */
export const PermissionAddRequestPermissionEnum = {
    ManageButtons: 'MANAGE_BUTTONS',
    ManageDomain: 'MANAGE_DOMAIN',
    ChatAgent: 'CHAT_AGENT'
} as const;
export type PermissionAddRequestPermissionEnum = typeof PermissionAddRequestPermissionEnum[keyof typeof PermissionAddRequestPermissionEnum];


/**
 * Check if a given object implements the PermissionAddRequest interface.
 */
export function instanceOfPermissionAddRequest(value: object): value is PermissionAddRequest {
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('permission' in value) || value['permission'] === undefined) return false;
    return true;
}

export function PermissionAddRequestFromJSON(json: any): PermissionAddRequest {
    return PermissionAddRequestFromJSONTyped(json, false);
}

export function PermissionAddRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionAddRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'memberId': json['memberId'],
        'permission': json['permission'],
    };
}

export function PermissionAddRequestToJSON(json: any): PermissionAddRequest {
    return PermissionAddRequestToJSONTyped(json, false);
}

export function PermissionAddRequestToJSONTyped(value?: PermissionAddRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'memberId': value['memberId'],
        'permission': value['permission'],
    };
}

